module.exports = __webpack_public_path__ + "media/loading.ed9f3717.mp3";